function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import moduleStyles from '@dtsl/css-checkbox/dist/index.module.css';
export const Checkbox = _ref => {
  let {
    variant,
    name,
    value,
    label,
    disabled,
    identifier,
    labelClassName,
    // for the title of the checkbox
    labelContainerClassName,
    ellipsis,
    className,
    labelContainerStyle,
    ...rest
  } = _ref;
  const titleClass = classNames({
    [moduleStyles['sib-checkbox-title']]: true,
    [moduleStyles['sib-checkbox-ellipsis']]: ellipsis,
    [labelClassName]: !!labelClassName
  });
  const labelClass = classNames({
    [moduleStyles['sib-checkbox-label']]: true,
    [labelContainerClassName]: !!labelContainerClassName
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${moduleStyles['sib-checkbox-wrapper']} ${className}`
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    id: identifier,
    name: name,
    value: value,
    className: moduleStyles['sib-checkbox-input'],
    disabled: disabled,
    "aria-label": !label ? 'checkbox-label' : null
  }, rest)), /*#__PURE__*/React.createElement("label", {
    htmlFor: identifier,
    style: {
      ...labelContainerStyle
    },
    className: labelClass
  }, /*#__PURE__*/React.createElement("span", {
    className: `${moduleStyles['sib-checkbox']} ${moduleStyles[`sib-checkbox_tick_${variant}`]}`
  }), /*#__PURE__*/React.createElement("span", {
    className: titleClass
  }, label)));
};
Checkbox.propTypes = {
  variant: PropTypes.oneOf(['positive', 'negative', 'undetermined']),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  identifier: PropTypes.string.isRequired,
  ellipsis: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  labelContainerClassName: PropTypes.string,
  labelContainerStyle: PropTypes.object
};
Checkbox.defaultProps = {
  variant: 'positive',
  label: null,
  name: null,
  value: '',
  disabled: false,
  identifier: null,
  ellipsis: false,
  className: '',
  labelClassName: '',
  labelContainerClassName: '',
  labelContainerStyle: {}
};
export default Checkbox;